module.exports = __webpack_public_path__ + "img/u2964.af6da9d6.png";